// MyPayslipsPage — 1:1 port of the "My Payslips" tab on the WP employee portal.
// Renders the authenticated user's payroll history (newest first).

import React, { useEffect, useState } from "react";
import { useToast } from "@chakra-ui/react";
import { api } from "../../lib/api";
import { useShellHeader } from "../../Components/AppShell";
import { Card, CardHeader, EmptyState, Skeleton } from "../../Components/ui";

function inr(n) {
  return Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
function fmt(d) {
  return d ? new Date(d).toISOString().slice(0, 10) : "—";
}

export default function MyPayslipsPage() {
  const toast = useToast();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useShellHeader({ title: "My Payslips", breadcrumb: "Pay history" }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await api("/payroll/my");
        setRows(Array.isArray(data) ? data : []);
      } catch (e) {
        toast({ title: e.message, status: "error" });
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <Skeleton lines={5} />;

  if (!rows.length) {
    return (
      <Card>
        <CardHeader title="My Payslips" subtitle="Your pay history will appear here once HR generates payroll." />
        <EmptyState title="No payslips yet" message="You don't have any payroll records for now. Check back after the next payroll run." />
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader title="My Payslips" subtitle={`${rows.length} record(s)`} />
      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ background: "var(--bg-subtle)", textAlign: "left" }}>
              {["Period", "Base Salary (₹)", "Deductions (₹)", "Bonuses (₹)", "Net Pay (₹)", "Status"].map((h) => (
                <th key={h} style={{ padding: "10px 12px", fontWeight: 600, color: "var(--text-secondary)", borderBottom: "1px solid var(--border-default)" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r._id} style={{ borderBottom: "1px solid var(--border-subtle)" }}>
                <td style={{ padding: "10px 12px" }}>{fmt(r.periodStart)} → {fmt(r.periodEnd)}</td>
                <td style={{ padding: "10px 12px" }}>{inr(r.baseSalary)}</td>
                <td style={{ padding: "10px 12px" }}>{inr(r.deductions)}</td>
                <td style={{ padding: "10px 12px" }}>{inr(r.bonuses)}</td>
                <td style={{ padding: "10px 12px", fontWeight: 600 }}>{inr(r.netPay)}</td>
                <td style={{ padding: "10px 12px", textTransform: "capitalize" }}>{r.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
}
